/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Missing_Items_BothInputs */

const en_missing_items_both = /** @type {(inputs: Missing_Items_BothInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A credit note and a later shipment`)
};

/**
* | output |
* | --- |
* | "A credit note and a later shipment" |
*
* @param {Missing_Items_BothInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const missing_items_both = /** @type {((inputs?: Missing_Items_BothInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Missing_Items_BothInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_missing_items_both(inputs)
});